var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FileDisplay } from './FileDisplay';
import { Container, LeftBar, Content, } from './styles';
export var BaseRow = function (_a) {
    var leftBarColor = _a.leftBarColor, _b = _a.leftBarWidth, leftBarWidth = _b === void 0 ? 4 : _b, _c = _a.leftBarBorderRadius, leftBarBorderRadius = _c === void 0 ? 24 : _c, header = _a.header, content = _a.content, files = _a.files, filesContainerStyle = _a.filesContainerStyle, fileThumbStyle = _a.fileThumbStyle, containerStyle = _a.containerStyle, contentStyle = _a.contentStyle;
    return (React.createElement(Container, { style: containerStyle },
        React.createElement(LeftBar, { width: leftBarWidth, borderRadius: leftBarBorderRadius, color: leftBarColor }),
        React.createElement(Content, { style: contentStyle },
            header,
            content,
            files && files.length > 0 && (React.createElement(FileDisplay, { files: files, filesContainerStyle: __assign({}, filesContainerStyle), fileThumbStyle: __assign({}, fileThumbStyle) })))));
};
